import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const TRACKING_DOCUMENT_SCHEMA = Object.freeze({
  DOCUMENT_ID: null,
  DOCUMENT_LOCAL_ID: '',
  DOCUMENT_NUMBER: null,
  DOCUMENT_STATUS: '',
  DOCUMENT_REVISION_ID: null,
  DOCUMENT_TYPE: '',
});
const RECORD = generateSchema(TRACKING_DOCUMENT_SCHEMA);
const KEYS: any = generateKeys(TRACKING_DOCUMENT_SCHEMA);

export class DocumentTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.document;
  }

  get properties() {
    return this.toJS();
  }
}
